import React, { Fragment } from 'react';
import { styled } from 'styled-components';
import { Viewports } from '../../../../../play-core/styles/Viewports';
import { mobileHeaderHeight } from '../Header.globals';
import { useHeaderState } from '../HeaderContext';
import { MainNavigationLink } from './MainNavigationLink';
import { jsx as _jsx } from "react/jsx-runtime";
export const MainNavigationLinks = () => {
  const {
    config,
    showMainNavi,
    smallMainNavi,
    showMainNaviOnSmallScreens
  } = useHeaderState();
  return /*#__PURE__*/_jsx(Fragment, {
    children: showMainNavi && /*#__PURE__*/_jsx(Layout, {
      showMainNaviOnSmallScreens: showMainNaviOnSmallScreens,
      children: config.mainNavigation.map(link => /*#__PURE__*/_jsx(MainNavigationLink, {
        link: link,
        isCompact: showMainNavi && smallMainNavi
      }, link.path))
    })
  });
};
const Layout = styled.ul.withConfig({
  displayName: "MainNavigationLinks__Layout",
  componentId: "sc-167uuqg-0"
})(["display:flex;align-items:center;", "{order:3;width:100%;min-height:", "px;margin-left:-10px;display:", ";}"], Viewports.for('small'), mobileHeaderHeight, ({
  showMainNaviOnSmallScreens
}) => !showMainNaviOnSmallScreens && 'none');